import logo from './logo.svg';
import './App.css';
import EmployeeDataTable from './EmployeeDataTable';

function App() {
  return (
    <div className="App">
      <EmployeeDataTable/>
    </div>
  );
}

export default App;
